import { render, staticRenderFns } from "./TimetableCcolleges.vue?vue&type=template&id=78decbaa&scoped=true"
import script from "./TimetableCcolleges.vue?vue&type=script&lang=js"
export * from "./TimetableCcolleges.vue?vue&type=script&lang=js"
import style0 from "./TimetableCcolleges.vue?vue&type=style&index=0&id=78decbaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78decbaa",
  null
  
)

export default component.exports